import React, {useCallback, useEffect, useState} from "react";
import {ModalOverlay} from "components/Modal";
import styled from "styled-components";
import {ButtonPrimary, CheckBox, FormGroup} from "components/FormElements";
import {useDispatch, useSelector} from "react-redux";
import {userReturn} from "modules/actions";
import {ReturnFormNames} from "modules/utils";
import {isReturningUser} from "modules/selectors";
import banner from "assets/img/banner.jpg";
import {Link, useLocation} from "react-router-dom";

const Modal = styled.div`
	background: #fff;
	width: 100%;
	max-width: 414px;
	box-sizing: border-box;
	max-height: 100%;
	max-height: 100vh;
	position: relative;
	overflow: auto;

	form > div {
		margin: 0 auto;
		width: 240px;
	}
	button {
		margin-top: 10px;
	}
`;
const ModalHeader = styled.header`
	height: 70px;
	color: #ffffff;
	font-size: 27px;
	letter-spacing: 0;
	line-height: 50px;
	text-align: center;
	font-weight: 600;
	img {
		height: 70px;
	}
`;
const ModalInner = styled.div`
	padding: 20px 37px 30px;
`;

const Text = styled.p`
	color: #232323;
	font-size: 14px;
	letter-spacing: 0;
	line-height: 19px;
	text-align: center;
	margin-bottom: 10px;
`;

export const ModalReturningUser: React.FC = () => {
	const dispatch = useDispatch();
	const is_returning_user = useSelector(isReturningUser);
	const location = useLocation();
	const [hide_modal, setModalState] = useState(!is_returning_user);
	const [values, updateValue] = useState({
		[ReturnFormNames.Sponsor]: false,
		[ReturnFormNames.Terms]: false,
	});
	const [isDisabled, handleSubmitButton] = useState(true);
	const terms_link = "/help/rules";

	// Hide modal and show Terms
	useEffect(() => {
		if (is_returning_user) {
			setModalState(location.pathname === terms_link);
		}
	}, [location.pathname, is_returning_user]);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<HTMLInputElement>) => {
			const {name, checked} = event.currentTarget;
			updateValue({
				...values,
				[name]: checked,
			});
		},
		[values]
	);

	const onSubmit = useCallback(
		(event: React.SyntheticEvent<HTMLFormElement>) => {
			event.preventDefault();
			event.stopPropagation();

			if (!event.currentTarget.checkValidity()) {
				return;
			}
			dispatch(
				userReturn({
					[ReturnFormNames.Sponsor]: values[ReturnFormNames.Sponsor] ? 1 : 0,
				})
			);
			setModalState(true);
		},
		[dispatch, values]
	);

	useEffect(() => {
		handleSubmitButton(!values[ReturnFormNames.Terms]);
	}, [values]);

	if (hide_modal) {
		return null;
	}
	return (
		<ModalOverlay>
			<Modal>
				<ModalHeader>
					<img src={banner} alt="" />
				</ModalHeader>
				<ModalInner>
					<Text>
						Welcome back to MotoGP™ Fantasy for 2023 season! Simply agree to the Terms
						and Conditions to pick up where you left off last year. Good luck!
					</Text>
					<form onSubmit={onSubmit}>
						<FormGroup>
							<CheckBox
								name={ReturnFormNames.Terms}
								title="Accepting the Terms & Conditions"
								tick_position="left"
								required={true}
								is_on_light={true}
								onChange={handleChange}>
								I have read and accept the{" "}
								<Link to={terms_link} rel="noopener noreferrer" target="_blank">
									legal conditions of the Fantasy MotoGP™ Game
								</Link>
								, confirming that I am over 16 years old
							</CheckBox>
						</FormGroup>
						<ButtonPrimary disabled={isDisabled} id="register-button" type="submit">
							NEXT
						</ButtonPrimary>
					</form>
				</ModalInner>
			</Modal>
		</ModalOverlay>
	);
};
